// import FooterBCGTalk from './footer';
// import HeaderBCHTalk from './header';
import dynamic from 'next/dynamic';

const HeaderBCHTalk = dynamic(
  import('./header'),
  { ssr: true }
);
const FooterBCGTalk = dynamic(
  import('./footer'),
  { ssr: true }
);
const LayoutBCGTalk = ({ children }: any) => {
  return (
    <>
      <HeaderBCHTalk />
      {children}
      <FooterBCGTalk />
    </>
  );
};

export default LayoutBCGTalk;
